import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { AADConfig } from '@virtus/common/auth/index';
import { authActions, authSelectors, IDPUser, RootState } from '@virtus/common/auth/reducer';

interface ReduxProps {
  isInitialized: boolean;
  isAuthenticated: boolean;
  isValidUser: boolean;
  user: IDPUser | null;
  error: string | null;
  emailAddress: string | null;
  //id_token: string | null;
}

interface OwnProps {
  config: AADConfig;
  render: (state: AuthenticationHandlerRenderProps) => React.ReactNode;
}

interface UserDispatch {
  login: () => void;
  logout: () => void;
}

interface ReduxDispatch {
  initializeAuth: (payload: AADConfig) => void;
  //getAccessDispatch: (payload: any) => void;
}

type Dispatch = ReduxDispatch & UserDispatch;

export type AuthenticationHandlerRenderProps = {
  isAuthenticated: boolean;
  isValidUser: any;
  user: any;
  emailAddress: string | null;
  error?: any;
} & UserDispatch;

export type AuthenticationHandlerProps = ReduxProps & Dispatch & OwnProps;

export const AuthenticationHandlerAdmin: React.FC<AuthenticationHandlerProps> = ({
  config,
  render,
  isInitialized,
  isAuthenticated,
  isValidUser,
  user,
  emailAddress,
  initializeAuth,
  login,
  logout,
}) => {
  const prevIsInitializedRef = useRef(isInitialized);

  // Only run initializeAuth on mount
  useEffect(() => {
    initializeAuth(config);
  }, [initializeAuth, config]);

  // Only run login when isInitialized changes, never during render
  useEffect(() => {
    if (!prevIsInitializedRef.current && isInitialized && !user) {
      login();
    }
    prevIsInitializedRef.current = isInitialized;
  }, [isInitialized, user, login]);

  // Defensive: never call login during render
  // Defensive: never call any state update during render
  return (
    <>
      {user &&
        isInitialized &&
        isValidUser &&
        render({ isAuthenticated, isValidUser, user, login, logout, emailAddress })}
    </>
  );
};

const mapStateToProps = (state: RootState): ReduxProps => {
  let data = {
    isInitialized: authSelectors.getStatus(state) === 'initialized',
    user: authSelectors.getUser(state),
    isValidUser: authSelectors.isValidUser(state),
    isAuthenticated: authSelectors.isAuthenticated(state),
    error: authSelectors.loginError(state),
    //id_token: authSelectors.getAccessToken(state),
    emailAddress: authSelectors.getEmailAddress(state),
  };
  return data;
};

const mapDispatchToProps: Dispatch = {
  initializeAuth: authActions.aadInitialize,
  login: authActions.aadLogin,
  logout: authActions.aadLogout,
  //getAccessDispatch: authActions.getAccessToken
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationHandlerAdmin as any);
